import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Checkbox, Menu, Dropdown, Spin, Input, /*Pagination, */ message, Tooltip } from 'antd';
// import { CheckOutlined } from '@ant-design/icons';
import moment from 'moment';
import './Table.scss';
import './Wcomponent.scss';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';
import FolderTabs from './FolderTabs';
import AddFolderDialog from './AddFolderDialog';
import MoveToOtherFolderDialog from './MoveToOtherFolderDialog';
import TransmissionList from './TransmissionList';
import { storageAppApi, collaborationApi } from "Api/index";
import { USER_SIGN_IN_SUCCESS } from 'Store/constants';
import { bytesTobytes, copyToClipboard } from 'Utils/utils';
import { /*convertController, */fileController } from "../viewer/Controllers/index";
import { OPEN_FILE_LOCAL } from '../viewer/ui/constants/openfile.constants';
import { SHARE_DOC } from 'Components/viewer/ui/constants/other.constants';
import Pagination from './ConfigPagination';

/**
 * @param {Documents|Recent|Starred} tabs - 标签类型
 * @param {boolean} [mini=false] - 是否mini表格
 * @param {boolean} [actionFileName=true] - 点击文件名成是否自动开始编辑文档
 * @param {boolean} [multiple=true] - 是否多选 
 * @param {boolean} [pagabled=true] - 是否可分页，只对Documents tab生效 
 * @param {function} [onOpenFile] - 打开文档 
 * @param {function} [onSelectChange] - 多选事件 
 * @param {function} [onFolderChange] - 文件夹改变事件 
 * @param {function} [onScrolling] - table滚动事件 
 */
@inject('storageAppStore')
@observer
class StorageTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [], // 标签 ['Documents', 'Recent', 'Starred']
            activeTab: '', // 当前激活tab
            list: [], // 表格列表数据
            checkList: [], // 表格复选框选中列表
            isLoading: false, // 是否加载中
            isTableOverable: false, // table是否有滚动条
            folderList: [
                // 'Document', 'Folder-1', 'Folder谢谢谢谢谢寻-2', 'Folder-3', 'Folder-4', 'Foldercccccccccccc-5', 'Folder-6', 'Folder-7', 'Folder-8', 'Folder-9',
            ], // 文件夹列表
            addFolderOption: { // 添加文件夹参数配置
                visible: false,
            },
            moveToOtherFolderOption: { // 移动文件夹参数配置
                visible: false,
            },
            currentRenameItem: '', // 当前rename对象
            pageIndex: 1, // 当前页
            pageSize: 20, // 每页数量
            totalPage: null, // 总页数
            documentPaginationOption: { // Document 分页配置
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            }, 
            orderBy: [], // 排序 ['lastModificationDate', 0] lastModificationDate升序 \ ['name', 1] name 降序
        };
        this.tbody = React.createRef();
        this.storageTable = React.createRef();
        this.initTab = this.initTab.bind(this);
    }
    componentDidMount () {
        store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, this.initTab);
        return this.initTab();
    }
    componentDidUpdate () {
        this.checkTableOverflow();
    }
    componentWillUnmount () {
        this.setState = () => false;
        store.appStore.removeAppEventListener(USER_SIGN_IN_SUCCESS, this.initTab);
    }
    initTab () {
        const { isDisableStorage } = store.storageAppStore;
        if (isDisableStorage) return ;
        this.setTabs((tabs) => {
            if (tabs && tabs.length > 0) {
                this.changeTab(tabs[0], this.props.onReady);
            }
        });
    }
    // 检查表格内容是否溢出
    checkTableOverflow () {
        const isOverflow = function (element) {
            if (!element) return false;
            return element.scrollHeight > (element.innerHeight || element.clientHeight);
        }
        const $storageTable = this.storageTable.current;
        const $tbody = this.tbody.current;
        if ($tbody) {
            const { isTableOverable } = this.state;
            const { mini, pagabled } = this.props;
            if ($storageTable) {
                const storageTableHeight = $storageTable.getBoundingClientRect().height;
                let toolHeadHeight = '36px - 5px';
                let theadHeight = '39px';
                let pagingHeight = '42px';
                if (!pagabled) pagingHeight = '0px';
                if (mini) {
                    toolHeadHeight = '22px - 5px';
                    theadHeight = '39px';
                    pagingHeight = '35px';
                }
                $tbody.style.maxHeight = `calc(${storageTableHeight}px - ${theadHeight} - ${toolHeadHeight} - ${pagingHeight})`;
            }
            const ret = isOverflow($tbody);
            isTableOverable !== ret && this.setState({ isTableOverable: ret });
        }
    }
    // ========================================接口∨========================================
    // 获取最近使用记录列表
    getRecentList () {
        let { pageIndex, pageSize, list, totalPage } = this.state;
        this.setLoading(true);
        return storageAppApi.getRecentList(pageIndex, pageSize).then(data => {
            if (data.length < pageSize) {
                totalPage = pageIndex;
            }
            this.setState({ 
                list: list.concat(data || []),
                totalPage
            });
        }).finally(() => {
            this.setLoading(false);
        });
    }
    // 获取收藏文件列表
    getStaredList () {
        let { pageIndex, pageSize, list, totalPage } = this.state;
        this.setLoading(true);
        return storageAppApi.getStarredList(pageIndex, pageSize).then(data => {
            if (data.length < pageSize) {
                totalPage = pageIndex;
            }
            this.setState({ 
                list: list.concat(data || []),
                totalPage
            });
        }).finally(() => {
            this.setLoading(false);
        });
    }
    // 打开文件夹，folderId不传表示查询根路径
    documentOpenFolder (folder) {
        this.setState({ checkList: [] });
        this.setLoading(true);
        let promise = Promise.resolve(folder);
        if (!folder) {
            promise = store.storageAppStore.getRootFolder();
        }
        return promise.then(folder => {
            let { pageIndex, pageSize } = this.props.pagabled ? this.state.documentPaginationOption : {};
            return storageAppApi.getChildren(folder.docId, pageIndex, pageSize, this.state.orderBy).then(({ pageIndex, pageSize, total, data }) => {
                const { folderList } = this.state;
                if (folderList.indexOf(folder) === -1) {
                    folderList.push(folder);
                }
                this.setState({ 
                    list: data, 
                    folderList, 
                    documentPaginationOption: { pageIndex, pageSize, total }
                });
                store.storageAppStore.setCurrentFolder(folder);
                this.props.onFolderChange && this.props.onFolderChange(folder);
            })
        }).finally(() => {
            this.setLoading(false);
        });
    }
    // 刷新当前Table数据
    reGetTableData () {
        const { activeTab } = this.state;
        if (activeTab === 'Recent') {
            this.setState({ list: [], pageIndex: 1 });
            this.getRecentList();
            this.addTableScrollEnd();
        } else if (activeTab === 'Starred') {
            this.setState({ list: [], pageIndex: 1 });
            this.getStaredList();
            this.addTableScrollEnd();
        } else if (activeTab === 'Documents') {
            // const folderList = this.state.folderList || [];
            // const last = folderList[folderList.length - 1];
            // this.documentOpenFolder(last);
        }
    }
    // 删除对象
    documentDeleteObjects (array) {
        if (!array || array.length === 0) return ;
        this.setLoading(true);
        return array.reduce((p, item) => {
            return p.then(() => {
                if (this.util_isFolder(item)) {
                    return storageAppApi.deleteTree(item.docId);
                } else {
                    return storageAppApi.deleteObject(item.docId);
                }
            });
        }, Promise.resolve()).then(() => {
            this.util_removeCheckListItems(array);
        }).finally(() => {
            this.setLoading(false);
            this.reGetTableData();
            store.storageAppStore.updateStorageSpaceSize();
        }).catch(() => {
            this.setState({ checkList: [] });
        });
    }
    // 创建文件夹
    createFolder (folderName) {
        const { folderList, addFolderOption } = this.state;
        if (!folderList || folderList.length === 0) return ;
        this.setLoading(true);
        const last = folderList[folderList.length - 1];
        storageAppApi.createFolder(last.docId, folderName).then(() => {
            this.setState({ addFolderOption: Object.assign(addFolderOption, { visible: false }) });
            this.reGetTableData();
        }).finally(() => {
            this.setLoading(false);
        }).catch(() => {
            message.error(intl.formatMessage({
                id: 'FoxitStorage.Error.DuplicateFolderName'
            }, {
                folderName: folderName
            }))
        });
    }
    // 重命名
    rename (e, data) {
        const suffix = store.storageAppStore.getSuffix(data.name);
        let newName = e.target.value.trim();
        if (store.storageAppStore.regExpName(newName)) return ;
        newName += suffix;
        this.setLoading(true);
        storageAppApi.rename(data.docId, newName).then(() => {
            data.name = newName;
            data.docName = newName;
            this.setState({ currentRenameItem: '' });
        }).finally(() => {
            this.setLoading(false);
        });
    }
    // 移动到其他目录
    moveToOtherFolder (target) {
        const { list, checkList, moveToOtherFolderOption } = this.state;
        const sources = moveToOtherFolderOption.sources;
        this.setState({ 
            moveToOtherFolderOption: Object.assign(moveToOtherFolderOption, { visible: false })
        });
        this.setLoading(true);
        sources.reduce((p, item) => {
            return p.then(() => {
                return storageAppApi.moveObject(item.docId, item.parentId, target).then(() => {
                    sources.splice(sources.indexOf(0), 1);
                    list.splice(list.indexOf(item), 1);
                    const index = this.util_indexOfCheckList(checkList, item);
                    checkList.splice(index, 1);
                    this.setState({ list, checkList });
                })
            });
        }, Promise.resolve()).finally(() => {
            this.reGetTableData();
            this.setLoading(false);
        });
    }
    hideMoveToOtherFolderDialog (updateDocumentList) {
        const { moveToOtherFolderOption } = this.state;
        moveToOtherFolderOption.visible = false;
        this.setState({ moveToOtherFolderOption });
        if (updateDocumentList) {
            this.reGetTableData();
        }
    }
    // 从CMIS上获取Doc文件，如果有文件夹，也会返回文件夹下的文档
    getDocFiles (dataList) {
        let promises = [];
        const folders = [];
        const documents = [];
        (dataList || []).forEach(item => {
            if (item.objectTypeId === 'folder') {
                folders.push(item);
            } else {
                documents.push(item);
            }
        });
        folders.forEach(item => {
            promises.push(
                storageAppApi.getChildren(item.docId).then(({ data }) => {
                    (data || []).forEach(sitem => {
                        if (sitem.objectTypeId === 'document') {
                            documents.push(sitem);
                        }
                    });
                })
            );
        });
        return Promise.all(promises).then(() => {
            promises = [];
            documents.forEach(item => {
                promises.push(
                    storageAppApi.getDocumentStream(item.docId).then(blob => {
                        const docName = item.name;
                        let option;
                        if (docName.toLowerCase().lastIndexOf('.pdf') > -1) {
                            option = { type: 'application/pdf' };
                        }
                        const file = new window.File([blob], docName, option);
                        return file;
                    })
                )
            });
            return Promise.all(promises); 
        });
    }
    // 获取共享文档信息
    getShareFileData (reviewSessionID, docId, isMe, errType) {
        if (reviewSessionID === undefined) return null;
        return collaborationApi.getShareReview({ 
            // cDocID, extDocID, 
            reviewSessionID, 
            getMore: 1
        }).then(ret => {
            if (!ret.data || ret.data.length === 0) {
                // 当前共享文档不存在
                if (errType === 'alert') {
                    const PDFUI = store.viewer.pdfui;
                    PDFUI.alert({ message: intl.get('FoxitStorage.Error.StopShare'), level: 'prompt' }).then(() => {
                        if (docId) {
                            isMe = (isMe === undefined) ? 1 : isMe;
                            isMe == 0 && storageAppApi.removeRecent(docId);
                            isMe == 0 && storageAppApi.removeStarred(docId);
                            this.reGetTableData();
                        }
                    });
                } else {
                    message.error(intl.get('collaboration.Dlg.stopShare'));
                    if (docId) {
                        isMe = (isMe === undefined) ? 1 : isMe;
                        isMe == 0 && storageAppApi.removeRecent(docId);
                        isMe == 0 && storageAppApi.removeStarred(docId);
                        this.reGetTableData();
                    }
                }
                return null;
            }
            return ret.data[0];
        });
    }
    // ========================================接口∧========================================
    // 设置tab配置
    setTabs (callback) {
        let { tabs } = this.props;
        if (!tabs) {
            tabs = ['Documents'];
        } else if (typeof tabs === 'string') {
            tabs = tabs.split(',');
        }
        this.setState({
            tabs: tabs.reduce((arr, item) => {
                const index = ['Documents', 'Recent', 'Starred'].indexOf(item);
                if (index > -1) arr.push(item);
                return arr;
            }, [])
        }, () => {
            callback(tabs);
        });
    }
    // 切换tab
    changeTab (tab, callback) {
        this.setState({
            activeTab: tab, 
            list: [], 
            checkList: [], 
            folderList: [],
            pageIndex: 1, 
            totalPage: null,
            documentPaginationOption: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            }, 
        }, () => {
            if (!store.userStore.token) return ;
            if (tab === 'Recent') {
                this.getRecentList();
            } else if (tab === 'Starred') {
                this.getStaredList();
            } else if (tab === 'Documents') {
                this.setState({
                    orderBy: ['lastModificationDate', 1]
                });
                this.documentOpenFolder().then(callback);
            }
            this.addTableScrollEnd();
        });
    }
    // 复选框全选点击事件
    onCheckAllChange () {
        let { list, checkList } = this.state;
        if (!list || list.length === 0) return ;
        if (list.length === checkList.length) { // 全选
            checkList = [];
        } else {
            checkList = list.map(item=>item);
        }
        this.setState({ checkList });
        this.props.onSelectChange && this.props.onSelectChange(checkList);
        store.userStore.doSendGAEvent({ action: 'Homepage_multiple_select', label: 'Home_Page', category: 'Foxit_Storage' });
    }
    // 复选框点击事件
    onCheckChange (data) {
        const { checkList } = this.state;
        const index = this.util_indexOfCheckList(checkList, data);
        if (index === -1) { // unchecked
            checkList.push(data);
        } else { // checked
            checkList.splice(index, 1);
        }
        this.setState({ checkList });
        this.props.onSelectChange && this.props.onSelectChange(checkList);
        store.userStore.doSendGAEvent({ action: 'Homepage_multiple_select', label: 'Home_Page', category: 'Foxit_Storage' });
    }
    // 功能按钮点击入口
    onToolClick (toolName, item) {
        if (store.appStore.isDisableButton(OPEN_FILE_LOCAL)) return;
        const PDFUI = store.viewer.pdfui;
        const items = item ? [item] : this.state.checkList;

        switch (toolName) {
            case 'AddStar': 
                this.setLoading(true);
                store.userStore.doSendGAEvent({ action: 'Homepage_Star', label: 'Home_Page', category: 'Foxit_Storage' });
                const isMe = (item.isMe === undefined) ? 1 : item.isMe;
                let p = Promise.resolve(true);
                if (item.reviewSessionID) {
                    p = this.getShareFileData(item.reviewSessionID, item.docId, item.isMe)
                }
                p.then(ret => {
                    if (!ret) return;
                    storageAppApi.addStarred(item.docId, item.docName, isMe, item.docSize).then(() => {
                        item.isStarred = true;
                    }).finally(() => {
                        this.setLoading(false);
                    });
                });
                break;
            case 'CopySharedLink': 
                if (store.appStore.isDisableButton(SHARE_DOC)) return;
                const reviewSessionID = item.reviewSessionID;
                if (reviewSessionID) {
                    this.getShareFileData(reviewSessionID, item.docId, item.isMe).then(res => {
                        if (res) {
                            const shareLink = `${location.origin}/?docUrl=${encodeURIComponent(res.fileLink)}&fileName=${encodeURIComponent(res.docName)}&reviewSessionID=${reviewSessionID}&al=${store.appStore.lng.full}`
                            copyToClipboard(shareLink, () => { 
                                message.success(intl.get('collaboration.Dlg.CopySuccessful'));
                            });
                        }
                    });
                }
                break;
            case 'UnshareFile': 
                PDFUI.confirm({
                    message: intl.get('FoxitStorage.Table.UnshareTip'),
                    level: 'prompt',
                    okText: intl.get('FoxitStorage.Table.UnshareText')
                }).then(() => {
                    this.setLoading(true);
                    const storageAppApiUnshare = (password) => {
                        return storageAppApi.unShare(item.reviewSessionID, password).then((data) => {
                            if (data.ret === 900006) {
                                // 密码错误
                                return store.storageAppStore.promptPassword(password).then(newPwd => {
                                    return storageAppApiUnshare(newPwd);
                                });
                            }
                            if (this.state.activeTab === 'Documents') {
                                this.reGetTableData();
                            } else {
                                item.reviewSessionID = undefined;
                            }
                        }).finally(() => {
                            this.setLoading(false);
                        });
                    }
                    return storageAppApiUnshare();
                }, () => {});
                break;
            case 'RemoveMe':
                this.setLoading(true);
                return this.removeMe(item).finally(() => {
                    this.setLoading(false);
                });
                break;
            case 'EditPdf': 
                this.openFile(items[0], () => {
                    PDFUI.getComponentByName('edit-tab').then(component => {
                        component && component.active();
                    });
                });
                break;
            case 'RequestSignatures': 
                this.openFile(items[0], () => {
                    PDFUI.getComponentByName('foxit-eSign').then(component => {
                        component && component.active();
                        PDFUI.customs.requestFoxitSign();
                    });
                });
                break;
            case 'AddComments': 
                this.openFile(items[0], () => {
                    PDFUI.getComponentByName('comment-tab').then(component => {
                        component && component.active();
                    });
                });
                break;
            case 'Organize': 
                this.openFile(items[0], () => {
                    PDFUI.getComponentByName('organize-tab').then(component => {
                        component && component.active();
                    });
                });
                break;
            case 'Convert': 
                const docName = items[0].name;
                const docId = items[0].docId;
                store.storageAppStore.doConvertToPDF(docId, docName).then(([url]) => {
                    if (url) {
                        store.taskStore.onUpdateTaskMessage({ status: 'task-step-finish', ret: 0, url, });
                    }
                });
                break;
            case 'Combine': 
                this.setLoading(true);
                this.getDocFiles(items).then(files => {
                    if (!files || files.length === 0) return ;
                    PDFUI.customs.showCombineDialog(files);
                }).finally(() => {
                    this.setLoading(false);
                });
                break;
            case 'Compress': 
                this.openFile(items[0], () => {
                    PDFUI.getComponentByName('convert-tab').then(component => {
                        component && component.active();
                        PDFUI.customs.showReduceFileSizeDialog();
                    });
                });
                break;
            case 'Protect': 
                this.openFile(items[0], () => {
                    PDFUI.getComponentByName('protect-tab').then(component => {
                        component && component.active();
                        setTimeout(() => {
                            PDFUI.getComponentByName('password-protect-btn').then(button => {
                                button && !button.disabled && button.controller && button.controller.handle(1);
                            });
                        }, 5500); // PasswordProtectCallbackController从初始化到changePermissiond大概3s的时间，故此这边需要5s的超时设置
                    });
                });
                break;
            case 'ShareWithOthers':
            case 'Share': 
                store.userStore.doSendGAEvent({ action: 'Homepage_Share', label: 'Home_Page', category: 'Foxit_Storage' });
                this.openShareDialog(item);
                break;
            case 'Rename': 
                this.renameInput = React.createRef();
                this.setState({ currentRenameItem: item }, () => {
                    let input = this.renameInput;
                    if (!input || !input.current) return ;
                    input = input.current.input;
                    if (input) {
                        input.select();
                        input.focus();
                    }
                });
                break;
            case 'Move': 
                const { folderList, moveToOtherFolderOption } = this.state;
                moveToOtherFolderOption.root = folderList[0];
                moveToOtherFolderOption.visible = true;
                moveToOtherFolderOption.sources = items;
                this.setState({ moveToOtherFolderOption });
                break;
            case 'Download': 
                this.download(items);
                break;
            case 'Delete': 
                let deleteAlertTips = intl.get('FoxitStorage.Table.SureToDeleteSelected');
                const shareList = items.filter((data) => {
                    return !!data.reviewSessionID;
                })
                if (items.length === 1) {
                    deleteAlertTips = items[0].reviewSessionID ? 
                        intl.get('FoxitStorage.Table.SureToDeleteShareFile'): 
                        intl.get('FoxitStorage.Table.SureToDelete', { filename: items[0].name });
                } else if (shareList && shareList.length > 0) {
                    deleteAlertTips = intl.get(
                        shareList.length === items.length ? 
                        'FoxitStorage.Table.SureToDeleteShareFiles': 
                        'FoxitStorage.Table.SureToDeleteNotUndone');
                }
                PDFUI.confirm({
                    message: deleteAlertTips,
                    level: 'prompt',
                    okText: intl.get('FoxitStorage.Table.DeleteText')
                }).then(() => {
                    this.documentDeleteObjects(items);
                }, () => {});
                break;
            case 'AddFolder': 
                const { addFolderOption } = this.state;
                store.userStore.doSendGAEvent({ action: 'Documents_add_folder', label: 'Event', category: 'Foxit_Storage' });
                this.setState({ addFolderOption: Object.assign(addFolderOption, { visible: true }) });
                break;
            case 'Upload': 
                {
                    // const { folderList, activeTab } = this.state;
                    // const isDocumentTab = activeTab === 'Documents';
                    // store.userStore.doSendGAEvent({ action: isDocumentTab ? 'Documents_upload_files' : 'Homepage_upload_files', label: isDocumentTab ? 'Event' : 'Home_Page', category: 'Foxit_Storage' });
                    // let last = folderList[folderList.length - 1];
                    // store.storageAppStore.uploadFileFromeLocal(last, () => {
                    //     if (isDocumentTab) {
                    //         this.reGetTableData();
                    //     } else {
                    //         this.changeTab(activeTab === 'Starred' ? 'Recent' : activeTab);
                    //     }
                    // });
                }
                break;
            case 'Clear': 
                store.userStore.doSendGAEvent({ action: 'Homepage_clear_list', label: 'Home_Page', category: 'Foxit_Storage' });
                PDFUI.confirm({
                    message: intl.get('FoxitStorage.Table.ClearAll'),
                    level: 'prompt',
                    okText: intl.get('FoxitStorage.Yes'),
                    cancelText: intl.get('FoxitStorage.No')
                }).then(() => {
                    this.setLoading(true);
                    storageAppApi.clearRecent().then(() => {
                        this.reGetTableData();
                    }).finally(() => {
                        this.setLoading(false);
                    });
                }, () => {});
                break;
            case 'RemoveStar': 
                this.setLoading(true);
                store.userStore.doSendGAEvent({ action: 'Homepage_unStar', label: 'Home_Page', category: 'Foxit_Storage' });
                storageAppApi.removeStarred(item.docId).then(() => {
                    if (this.state.activeTab === 'Starred') {
                        this.reGetTableData();
                    } else {
                        item.isStarred = false;
                    }
                }).finally(() => {
                    this.setLoading(false);
                });
                break;
            case 'OpenFolder': 
                // this.documentOpenFolder(item);
                break;
        }
    }
    // 文件夹列表tab 切换事件
    onFolderTabsChange (data) {
        this.setState({ 
            folderList: data,
            documentPaginationOption: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            }, 
        }, () => {
            this.reGetTableData();
        });
    }
    // 分页
    onPaginationChange (pageIndex) {
        const documentPaginationOption = this.state.documentPaginationOption;
        documentPaginationOption.pageIndex = pageIndex;
        this.setState({ documentPaginationOption }, () => {
            this.reGetTableData();
        });
    }
    onPaginationPageSizeChange = (e, pageSize) => {
        const documentPaginationOption = this.state.documentPaginationOption;
        documentPaginationOption.pageSize = pageSize;
        documentPaginationOption.pageIndex = 1;
        this.setState({ documentPaginationOption });
    }
    // 表格滚动到底部事件
    onTableScrolling = (e) => {
        var target = e.target;
        var scrollTop = target.scrollTop;
        var scrollHeight = target.scrollHeight;
        var clientHeight = target.clientHeight;
        var maxScrollTop = scrollHeight - clientHeight;
        const { activeTab, pageIndex, totalPage } = this.state;
        if ((scrollTop === maxScrollTop) && (totalPage !== pageIndex)) {
            this.setState({
                pageIndex: pageIndex + 1
            }, () => {
                if (activeTab === 'Recent') {
                    this.getRecentList();
                } else if (activeTab === 'Starred') {
                    this.getStaredList();
                }
            });
        }
        this.props.onScrolling && this.props.onScrolling(scrollTop);
    }
    addTableScrollEnd () {
        if (!this.tbody || !this.tbody.current) {
            setTimeout(() => { this.addTableScrollEnd() }, 1500);
        } else {
            this.tbody.current.removeEventListener('scroll', this.onTableScrolling);
            this.tbody.current.addEventListener('scroll', this.onTableScrolling);
        }
    }
    // 打开文档
    openFile (data, onSuccess) {
        if (store.appStore.isDisableButton(OPEN_FILE_LOCAL)) return;
        if (!data?.reviewSessionID) {
            this.setLoading(true);
        }

        const folderList = this.state.folderList;
        store.storageAppStore.setCurrentFolder(folderList[folderList.length - 1]);
        const isMe = (data.isMe === undefined) ? 1 : data.isMe;
        const { activeTab } = this.state // 标签 ['Documents', 'Recent', 'Starred']
        const reviewSessionID = data.reviewSessionID;
        const docName = data.name;
        const isPdfFile = this.util_isPdfFile(docName);
        const docId = data.docId;
        let lastData = data;
        let promise = Promise.resolve(data);
        if (!reviewSessionID && docId.indexOf(',') === -1) {
            promise = storageAppApi.getObjectById(docId);
        }
        return promise.then((data) => {
            lastData = data;
            store.storageAppStore.onCreateShareSuccess = undefined;
            switch (activeTab) {
                case 'Documents': 
                    store.userStore.doSendGAEvent({ action: 'Documents_open_file', label: 'Event', category: 'Foxit_Storage' });
                    break;
                case 'Recent': 
                    store.userStore.doSendGAEvent({ action: isPdfFile ? 'Homepage_recent_click_open_file' : 'Homepage_recent_click_convert_file_then_open', label: 'Home_Page', category: 'Foxit_Storage' });
                    break;
                case 'Starred': 
                    store.userStore.doSendGAEvent({ action: isPdfFile ? 'Homepage_starred_click_open_file' : 'Homepage_starred_click_convert_file_then_open', label: 'Home_Page', category: 'Foxit_Storage' });
                    break;
            }
            
            if (reviewSessionID) {
                store.collaborationStore.setReviewSessionID(reviewSessionID)

                return this.getShareFileData(reviewSessionID, docId, data.isMe).then(ret => {
                    this.props.onOpenFile && this.props.onOpenFile();
                    if (ret) {
                        this.setLoading(false);
                        return store.collaborationStore.openSharedFile({ 
                            fileLink: ret.fileLink, 
                            docName: ret.docName,  
                            reviewSessionID
                        }).then(_ => {
                            store.storageAppStore.setCurrentDoc(data);
                            return _;
                        });
                    }

                    store.collaborationStore.resetCollaborationData()
                    
                    return Promise.reject();
                });
            } 
            if (isPdfFile) { // 1M以上的文件使用分片渲染方式
                const PDFUI = store.viewer.pdfui;
                const chunk = 1 * 1024 * 1024;
                const docSize = data.docSize;
                if (docSize > chunk) {
                    this.setLoading(false);
                    this.props.onOpenFile && this.props.onOpenFile();
                    const ab = new ArrayBuffer(docSize);
                    const blob = new Blob([ab]);
                    const file = new window.File([blob], docName, { type: 'application/pdf' });
                    store.storageAppStore.setCurrentDoc(data);
                    return PDFUI.openPDFByFile(file, { 
                        fileName: docName,
                        ReadBlockOption: {
                            url: storageAppApi.getDocumentStreamUrl(lastData.docId),
                            chunk,
                            headers: {
                                Authorization: `Bearer ${store.userStore.token}`,
                            }
                        }
                    }).then(() => {
                        store.storageAppStore.setCurrentDoc(data);
                        setTimeout(() => { 
                            onSuccess && onSuccess(); 
                        }, 1000);
                    });
                }
            } else {
                this.props.onOpenFile && this.props.onOpenFile();
                return store.storageAppStore.doConvertToPDF(lastData.docId, docName).then(([url, newDocName]) => {
                    store.taskStore.setTaskMessage(null);
                    if (!url) return ;
                    return fileController.doOpenFileByUrl(url, newDocName, null, true, () => {
                        setTimeout(() => { onSuccess && onSuccess(); }, 1000);
                    });
                });
            }
            return this.getDocFiles([data]).then(files => {
                if (!files || files.length === 0) return ;
                const file = files[0];
                this.setLoading(false);
                this.props.onOpenFile && this.props.onOpenFile();
                store.storageAppStore.setCurrentDoc(data);
                return store.viewer.doOpenFile(file, null, docName).then(() => {
                    store.storageAppStore.setCurrentDoc(data);
                    setTimeout(() => { 
                        onSuccess && onSuccess(); 
                    }, 1000);
                });
            })
        }).then(() => {
            storageAppApi.addRecent(lastData.docId, lastData.docName, isMe, lastData.docSize, reviewSessionID);
        }).finally(() => {
            this.setLoading(false);
        });
    }
    // 获取选中的文档数据，返回file list
    getSelectFiles () {
        const { checkList } = this.state;
        this.setLoading(true);
        return this.getDocFiles(checkList).finally(() => {
            this.setLoading(false);
        });
    }
    // 打开创建协作文档弹窗
    openShareDialog (data) {
        const PDFUI = store.viewer.pdfui;
        const isAccountExpired = PDFUI.customs && PDFUI.customs.isAccountExpired && PDFUI.customs.isAccountExpired(true);
        if (isAccountExpired) return;
        store.storageAppStore.checkShareFileSize(data.docSize).then(() => {
            store.storageAppStore.setCurrentDoc(data);
            store.storageAppStore.onCreateShareSuccess = (res) => {
                if (this.state.activeTab === 'Documents') {
                    this.reGetTableData();
                } else {
                    data.reviewSessionID = res.reviewSessionID;
                }
            };
            store.storageAppStore.onCloseShareModal = () => {
                store.storageAppStore.setCurrentDoc(null);
                store.storageAppStore.onCreateShareSuccess = null;
                store.storageAppStore.onCloseShareModal = null;
            };
            store.collaborationStore.isShowShareDialog = true;
        });
    }
    download (array) {
        if (!array || array.length === 0) return ;
        this.setLoading(true);
        if (array.length === 1) {
            const item = array[0];
            const isFolder = this.util_isFolder(item);
            const reviewSessionID = item.reviewSessionID;
            if (isFolder) {
                // 下载文件夹
                return storageAppApi.downloadFolder(item.objectId).then(url => {
                    url && window.open(url.replace('filename=stream', `filename=${item.docName}`));
                }).finally(() => {
                    this.setLoading(false);
                });
            } else if (reviewSessionID) {
                // 下载共享文档
                return this.getShareFileData(reviewSessionID, item.docId, item.isMe).then(res => {
                    if (res) {
                        const collaborationStoreDownloadFile = (password) => {
                            const sendData = {
                                confText: {
                                    listnewUrl: `reviewSessionID=${reviewSessionID}&getYourself=1&lastTime=0000-00-00%2000%3A00%3A00%3A000&pageObjNum=-1`,
                                },
                                documents: [{ url: res.fileLink, password }],
                                filename: item.docName
                            }
                            return store.collaborationStore.downloadFile(sendData).then(url => {
                                if (url) {
                                    window.location.href = url;
                                }
                            }, err => {
                                if (err.ret === 900006) {
                                    // 密码错误
                                    return store.storageAppStore.promptPassword(password).then(newPwd => {
                                        return collaborationStoreDownloadFile(newPwd);
                                    });
                                }
                            });
                        }
                        return collaborationStoreDownloadFile();
                    }
                }).finally(() => {
                    this.setLoading(false);
                });
            } else {
                // 下载普通文档
                return storageAppApi.getDocumentStream(item.docId).then(blob => {
                    const link = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.download = item.name;
                    a.href = link;
                    a.click();
                }).finally(() => {
                    this.setLoading(false);
                });
            }
        } else {
            // 下载zip
            const docIds = [];
            const shareFiles = [];
            const promises = [];
            array.forEach(item => {
                const reviewSessionID = item.reviewSessionID;
                if (reviewSessionID) {
                    promises.push(
                        this.getShareFileData(reviewSessionID, item.docId, item.isMe).then(res => {
                            if (res) {
                                shareFiles.push({ fileLink: res.fileLink, reviewSessionID });
                            }
                        })
                    );
                } else {
                    docIds.push(item.docId);
                }
            });
            return Promise.all(promises).then(() => {
                return storageAppApi.downloadFiles(docIds, shareFiles).then(url => {
                    url && window.open(url.replace('filename=stream', `filename=PDF Files`));
                });
            }).finally(() => {
                this.setLoading(false);
            });
        }
    }
    // 把我移除共享文档
    removeMe (data) {
        return this.getShareFileData(data.reviewSessionID, data.docId, data.isMe, 'alert').then(res => {
            if (res) {
                const PDFUI = store.viewer.pdfui;
                PDFUI.confirm({
                    message: intl.get('collaboration.sharedList.SharedTableAction.modelRemoveMeContent'),
                    level: 'prompt',
                    okText: intl.get('collaboration.sharedList.SharedTableAction.modelRemoveMeConfirmBtnText')
                }).then(() => {
                    this.setState({ isLoading: true });
                    let promise;
                    if (res.cUserID === store.userStore.userId) {
                        promise = Promise.resolve({ ret: 0 });
                    } else {
                        promise = store.collaborationStore.putShareReviewInviteParticipantBatch({
                            reviewSessionIDs: [data.reviewSessionID],
                            isJoin: 0
                        });
                    }
                    return promise.then(res => {
                        if (res.ret === 0) {
                            return Promise.all([
                                storageAppApi.removeRecent(data.docId), 
                                storageAppApi.removeStarred(data.docId)
                            ]).then(() => {
                                this.util_removeCheckListItems([data]);
                                this.reGetTableData();
                            });
                        }
                    }).finally(() => {
                        this.setLoading(false);
                    });
                }, () => {});
            }
        });
    }
    setOrderBy (type) {
        let { activeTab, orderBy } = this.state;
        if (activeTab !== 'Documents') return ;
        if (!['lastModificationDate', 'name'].includes(type)) return ;
        if (orderBy && orderBy[0] === type) {
            let val = orderBy[1];
            orderBy = [type, val === 1 ? 0 : 1]
        } else {
            orderBy = [type, 1];
        }
        this.setState({ orderBy }, () => {
            this.reGetTableData();
        });
    }
    setLoading (data) {
        this.setState({ isLoading: data });
    }
    // More 下拉菜单
    renderMoreDropdownMenu (data) {
        const isFolder = this.util_isFolder(data);
        const { activeTab } = this.state;
        const reviewSessionID = data.reviewSessionID;
        const isMe = (data.isMe === undefined) ? 1 : data.isMe;
        const isPdfFile = this.util_isPdfFile(data.docName);

        const expression1 = !isFolder && isPdfFile && !reviewSessionID;
        const expression2 = !isFolder && !isPdfFile;
        return (
            <Menu onClick={(e)=>this.onToolClick(e.key,data)}>
                {
                    (expression1 || expression2) && <Menu.ItemGroup key="g-1">
                    {
                        expression1 && <Menu.Item key="EditPdf">{intl.get('FoxitStorage.Table.Menu.EditPDF')}</Menu.Item>
                    }
                    {
                        expression1 && <Menu.Item key="AddComments">{intl.get('FoxitStorage.Table.Menu.AddComments')}</Menu.Item>
                    }
                    {
                        expression1 && <Menu.Item key="Protect">{intl.get('FoxitStorage.Table.Menu.Protect')}</Menu.Item>
                    }
                    {
                        expression1 && <Menu.Item key="RequestSignatures">{intl.get('FoxitStorage.Table.Menu.RequestSignatures')}</Menu.Item>
                    }
                    {
                        expression1 && <Menu.Item key="Compress">{intl.get('FoxitStorage.Table.Menu.Compress')}</Menu.Item>
                    }
                    {
                        expression1 && <Menu.Item key="Combine">{intl.get('FoxitStorage.Table.Menu.Combine')}</Menu.Item>
                    }
                    {
                        expression1 && <Menu.Item key="Organize">{intl.get('FoxitStorage.Table.Menu.Organize')}</Menu.Item>
                    }
                    {
                        expression2 && <Menu.Item key="Convert">{intl.get('FoxitStorage.Table.Menu.Convert')}</Menu.Item>
                    }
                    </Menu.ItemGroup>
                }
                {
                    !isFolder && reviewSessionID && <Menu.ItemGroup key="g-2">
                    {
                        <Menu.Item key="CopySharedLink">{intl.get('FoxitStorage.Table.Menu.CopySharedLink')}</Menu.Item>
                    }
                    {
                        isMe === 1 && <Menu.Item key="UnshareFile">{intl.get('FoxitStorage.Table.Menu.Unshare')}</Menu.Item>
                    }
                    {
                        isMe === 0 && <Menu.Item key="RemoveMe">{intl.get('FoxitStorage.Table.Menu.RemoveMe')}</Menu.Item>
                    }
                    </Menu.ItemGroup>
                }
                <Menu.ItemGroup key="g-3">
                {
                    !isFolder && isPdfFile && !reviewSessionID && <Menu.Item key="Share">{intl.get('FoxitStorage.Table.Menu.Share')}</Menu.Item>
                }
                {
                    !isFolder && !data.isStarred && <Menu.Item key="AddStar">{intl.get('FoxitStorage.Table.Menu.AddStarred')}</Menu.Item>
                }
                {
                    isMe === 1 && <Menu.Item key="Rename">{intl.get('FoxitStorage.Table.Menu.Rename')}</Menu.Item>
                }
                {
                    activeTab === 'Documents' && <Menu.Item key="Move">{intl.get('FoxitStorage.Table.Menu.Move')}</Menu.Item>
                }
                {
                    <Menu.Item key="Download">{intl.get('FoxitStorage.Table.Menu.Download')}</Menu.Item>
                }
                {
                    isMe === 1 && <Menu.Item key="Delete">{intl.get('FoxitStorage.Table.Menu.Delete')}</Menu.Item>
                }
                </Menu.ItemGroup>
            </Menu>
        );
    }
    // Tools 下拉菜单
    renderToolsDropdownMenu () {
        return (
            <Menu onClick={(e)=>this.onToolClick(e.key)}>
                <Menu.Item key="EditPdf"><span className="wc-icon edit-pdf"></span>{intl.get('FoxitStorage.Table.Menu.EditPDF')}</Menu.Item>
                <Menu.Item key="ShareWithOthers"><span className="wc-icon share-with-others"></span>{intl.get('FoxitStorage.Table.Menu.ShareWithOthers')}</Menu.Item>
                <Menu.Item key="RequestSignatures"><span className="wc-icon request-signatures"></span>{intl.get('FoxitStorage.Table.Menu.RequestSignatures')}</Menu.Item>
                <Menu.Item key="AddComments"><span className="wc-icon add-comments"></span>{intl.get('FoxitStorage.Table.Menu.AddComments')}</Menu.Item>
                <Menu.Item key="Organize"><span className="wc-icon organize"></span>{intl.get('FoxitStorage.Table.Menu.Organize')}</Menu.Item>
                <Menu.Item key="Combine"><span className="wc-icon combine"></span>{intl.get('FoxitStorage.Table.Menu.Combine')}</Menu.Item>
                <Menu.Item key="Compress"><span className="wc-icon compress"></span>{intl.get('FoxitStorage.Table.Menu.Compress')}</Menu.Item>
                <Menu.Item key="Protect"><span className="wc-icon protect"></span>{intl.get('FoxitStorage.Table.Menu.Protect')}</Menu.Item>
            </Menu>
        );
    }
    // Tools
    renderToolList () {
        let folderCount = 0; // 文件夹数量
        let otherFileCount = 0; // 属于别人的文档数量
        const { mini = false } = this.props;
        const { activeTab, checkList, list } = this.state; // ['Documents', 'Recent', 'Starred']
        checkList.forEach(item => {
            if (this.util_isFolder(item)) {
                folderCount += 1;
            }
            const isMe = (item.isMe === undefined) ? 1 : item.isMe;
            if (isMe !== 1) {
                otherFileCount += 1;
            }
        })
        return (
            <div className='storage-table-tools'>
                {
                    // checkList && checkList.length > 0 && <Dropdown overlayClassName='storage-ant-dropdown' overlay={this.renderToolsDropdownMenu()}>
                    //     <button className='wc-button'><a className="wc-icon tools"></a>Tools</button>
                    // </Dropdown>
                }
                {
                    activeTab === 'Documents' && checkList && checkList.length > 0 && <button className='wc-button' onClick={()=>this.onToolClick('Move')}><a className="wc-icon move"></a>{intl.get('FoxitStorage.Table.Menu.Move')}</button>
                }
                {
                    checkList && checkList.length > 0 && (folderCount === 0 || (folderCount === 1 && checkList.length === 1)) && <button className='wc-button' onClick={()=>this.onToolClick('Download')}><a className="wc-icon download"></a>{intl.get('FoxitStorage.Table.Menu.Download')}</button>
                }
                {
                    checkList && checkList.length > 0 && otherFileCount === 0 && <button className='wc-button' onClick={()=>this.onToolClick('Delete')}><a className="wc-icon delete"></a>{intl.get('FoxitStorage.Table.Menu.Delete')}</button>
                }
                <button className='wc-button upload-files' onClick={()=>this.onToolClick('Upload')}><a className="wc-icon upload"></a>{intl.get('FoxitStorage.Table.Menu.UploadFiles')}</button>
                {
                    activeTab === 'Documents' && <button className='wc-button' onClick={()=>this.onToolClick('AddFolder')}><a className="wc-icon add-folder"></a>{intl.get('FoxitStorage.Table.Menu.AddFolder')}</button>
                }
                {
                    !mini && <TransmissionList onReuploadSuccess={()=>this.reGetTableData()}></TransmissionList>
                }
                {
                    activeTab === 'Recent' && <button className='wc-button' disabled={list&&list.length?false:true} onClick={()=>this.onToolClick('Clear')}><a className="wc-icon clear"></a>{intl.get('FoxitStorage.Table.Menu.ClearList')}</button>
                }
            </div>
        )
    }
    // 没有记录Render
    renderEmpty () {
        const { activeTab } = this.state;
        const { mini = false } = this.props;
        if (activeTab === 'Documents') {
            return <div className='empty-content'>
                <p className='title'>{intl.get('FoxitStorage.Table.Empty.Documents.Title')}</p>
                {
                    !mini && <>
                        <p>{intl.get('FoxitStorage.Table.Empty.Documents.Desc')}</p>
                        <button className='wc-button-circle' type='theme' onClick={()=>this.onToolClick('Upload')}>{intl.get('FoxitStorage.Table.Menu.UploadFiles')}</button>
                    </>
                }
            </div>;
        } else if (activeTab === 'Recent') {
            return <div className='empty-content'>
                <p className='title'>{intl.get('FoxitStorage.Table.Empty.Recent.Title')}</p>
                <p>{intl.get('FoxitStorage.Table.Empty.Recent.Desc')}</p>
            </div>;
        } else if (activeTab === 'Starred') {
            return <div className='empty-content'>
                <p className='title'>{intl.get('FoxitStorage.Table.Empty.Starred.Title')}</p>
                <p>{intl.get('FoxitStorage.Table.Empty.Starred.Desc')}</p>
            </div>;
        } else {
            return <div className='empty-content'>
                <p className='title'>{intl.get('FoxitStorage.Table.Empty.Documents.Title')}</p>
                <p>{intl.get('FoxitStorage.Table.Empty.Documents.Desc')}</p>
            </div>;
        }
    }
    // 离线状态
    renderOffline () {
        return <div className='offline-content'>
            <p>{intl.get('FoxitStorage.Table.Offline')}</p>
        </div>;
    }
    // 未登录状态
    renderUnLogin () {
        return <div className='unlogin-content'>
            <p className='title'>{intl.get('FoxitStorage.Table.Empty.Unlogin.Title')}</p>
            <button className='wc-button-circle' type='theme' onClick={() => {
                if (!window.__online__) {
                    store.appStore.doNotifyErrors('offline');
                } else {
                    store.userStore.loginIn(null, { isFromUserHandleLogin: true });
                }
            }}>{intl.get('FoxitStorage.Table.Empty.Unlogin.Signin')}</button>
        </div>;
    }
    // 禁用状态
    renderDisableStorage () {
        return <div className='disable-content'>
            <p>{intl.get('FoxitStorage.DisableStorage.Table.Title')}</p>
            <p>{intl.get('FoxitStorage.DisableStorage.Table.Desc')}</p>
        </div>;
    }
    // ========================================工具========================================
    util_formatDate (date) {
        if (!date) return '--';
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }
    util_isFolder (data) {
        return data.objectTypeId && data.objectTypeId === 'folder';
    }
    util_isPdfFile (fileName) {
        return fileName.toLowerCase().endsWith('.pdf');
    }
    util_indexOfCheckList (checkList, data) {
        if (!checkList || checkList.length === 0) return -1;
        let ret = -1;
        for (let index = 0; index < checkList.length; index++) {
            const item = checkList[index];
            if (item.docId === data.docId) {
                ret = index;
                break;
            }
        }
        return ret;
    }
    util_removeCheckListItems (array) {
        if (!array || array.length === 0) return ;
        let checkList = JSON.parse(JSON.stringify(this.state.checkList));
        array.forEach(item => {
            const index = this.util_indexOfCheckList(checkList, item);
            if (index > -1) {
                checkList.splice(index, 1);
            }
        });
        this.setState({ checkList });
    }
    // 获取文件后缀类型
    util_getFileType = (filename) => {
        let type = 'default';
        if (!filename) return type;
        filename = filename.toLocaleLowerCase();
        let index = filename.lastIndexOf('.');
        let extension = filename.substr(index + 1);
        extension = extension.split('?')[0];
        const typeMap = {
            img: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp', 'ico', 'psd', 'svg', 'tiff'],
            video: ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv', 'video'],
            audio: ['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'],
            doc: ['doc', 'docx'],
            txt: ['txt'],
            ppdf: ['ppdf'],
            pdf: ['pdf'],
            code: ['html', 'js', 'css'],
            ppt: ['ppt', 'pptx'],
            xls: ['csv', 'xls', 'xlsx'],
            mind: ['km', 'mm', 'mmap', 'xmind'],
            zip: ['rar', 'zip', '7z', 'jar', 'gz'],
            outlook: ['outlook'],
            vsd: ['vsd'],
            xps: ['xps']
        };
        Object.keys(typeMap).forEach(_type => {
            const extensions = typeMap[_type];
            if (extensions.indexOf(extension) > -1) {
                type = _type;
                return type;
            }
        });
        return type;
    }
    render () {
        const { 
            tabs, list, checkList, activeTab, isLoading, isTableOverable, 
            folderList, addFolderOption, moveToOtherFolderOption,
            currentRenameItem, documentPaginationOption, orderBy, 
        } = this.state;
        const { mini = false, actionFileName = true, multiple = true, pagabled = false } = this.props;
        const { hasSignIn } = store.userStore;
        const { getPrevFileName, isOnline, isDisableStorage } = store.storageAppStore;
        const [orderName, orderType] = orderBy;
        const { lang } = store.appStore.lng;
       
        return (
            <div ref={this.storageTable} className={`storage-table${mini?' mini-table':''}${pagabled?' pagination':''}`} key={lang}>
                <Spin wrapperClassName='storage-ant-spin' tip="Loading..." spinning={isLoading}>
                    {
                        hasSignIn && !isDisableStorage && <header>
                            <div className='storage-table-title'>
                                {
                                    // Tab
                                    !folderList||folderList.length<2 && tabs.map(tab => <a key={tab} className={tabs.length>1&&activeTab===tab?'active':''} onClick={
                                        ()=>{
                                            if (store.appStore.isDisableButton(OPEN_FILE_LOCAL)) return;
                                            this.changeTab(tab);
                                        }
                                    }>{intl.get(`FoxitStorage.${tab}.Title`)}</a>)
                                }
                                {
                                    // 文件夹列表tab
                                    folderList&&folderList.length>1 && <FolderTabs folders={folderList} onChange={data=>this.onFolderTabsChange(data)}></FolderTabs>
                                }
                            </div>
                            {
                                // 右上角按钮列表
                                !mini && this.renderToolList()
                            }
                        </header>
                    }
                    {
                        // 断网情况
                        !isOnline && this.renderOffline()
                    }
                    {
                        // 未登录状态
                        isOnline && !hasSignIn && this.renderUnLogin()
                    }
                    {
                        // Storage禁用状态
                        isOnline && hasSignIn && isDisableStorage && this.renderDisableStorage()
                    }
                    {
                        // table数据为空
                        isOnline && hasSignIn && !isDisableStorage && (!list||list.length===0) && this.renderEmpty()
                    }
                    {
                        // table
                        isOnline && hasSignIn && !isDisableStorage && list&&list.length>0 && <table className={`wx-table${isTableOverable?' overable':''}`}>
                            <thead>
                                <tr>
                                    {
                                        multiple && <td className='wx-table-column-50'>
                                            <Checkbox indeterminate={checkList.length>0&&(checkList.length<list.length)} onChange={()=>this.onCheckAllChange()} checked={checkList.length>0&&(checkList.length===list.length)}></Checkbox>
                                        </td>
                                    }

                                    {
                                        activeTab!=='Documents' && <td className='file-name'>{intl.get('FoxitStorage.Table.Td.Name')}</td>
                                    }
                                    {
                                        activeTab==='Documents' && 
                                        <td className='file-name order-name' onClick={()=>this.setOrderBy('name')}>
                                            {intl.get('FoxitStorage.Table.Td.Name')}
                                            {
                                                orderName === 'name' && <a className={`wc-icon ${orderType===0?'order-asc':'order-des'}`}></a>
                                            }
                                        </td>
                                    }
                                    
                                    {
                                        !mini && <td className='operation'></td>
                                    }

                                    {
                                        !mini && <td className='status'>{intl.get('FoxitStorage.Table.Td.Status')}</td>
                                    }

                                    {
                                        activeTab!=='Documents' && <td>{intl.get(`FoxitStorage.Table.Td.${activeTab==='Recent'?'LastOpened':'LastModified'}`)}</td>
                                    }
                                    {
                                        activeTab==='Documents' && 
                                        <td className='order-modify' onClick={()=>this.setOrderBy('lastModificationDate')}>
                                            {intl.get(`FoxitStorage.Table.Td.LastModified`)}
                                            {
                                                orderName === 'lastModificationDate' && <a className={`wc-icon ${orderType===0?'order-asc':'order-des'}`}></a>
                                            }
                                        </td>
                                    }

                                    <td>{intl.get('FoxitStorage.Table.Td.Size')}</td>
                                    {
                                        !mini && <td className='wx-table-column-50'></td>
                                    }
                                </tr>
                            </thead>
                            <tbody ref={this.tbody}>
                                {
                                    list.map(item => {
                                        return <tr key={item.docId}>
                                            {
                                                multiple && <td className='wx-table-column-50'>
                                                    <Checkbox checked={this.util_indexOfCheckList(checkList,item)>-1} onChange={()=>this.onCheckChange(item)}></Checkbox>
                                                </td>
                                            }
                                            {
                                                this.util_isFolder(item) ? 
                                                <td className="file-name action">
                                                    <a className="wc-icon suffix folder"></a>
                                                    {
                                                        currentRenameItem === item ?
                                                        <Input ref={this.renameInput} className='rename-input' maxLength={200} defaultValue={getPrevFileName(item.name)} onPressEnter={e=>this.rename(e,item)} onBlur={e=>this.rename(e,item)} /> :
                                                        <Tooltip placement='topLeft' title={item.name}>
                                                            <span className='va-ml' onClick={()=>this.onToolClick('OpenFolder',item)}>{item.name}</span>
                                                        </Tooltip>
                                                    }
                                                </td> :
                                                <td className={`file-name${actionFileName?' action':''}`}>
                                                    <a className={`wc-icon ${mini?'file-icon':`suffix ${this.util_getFileType(item.name)}`}`}></a>
                                                    {
                                                        currentRenameItem === item ?
                                                        <Input ref={this.renameInput} className='rename-input' maxLength={200} defaultValue={getPrevFileName(item.name)} onPressEnter={e=>this.rename(e,item)} onBlur={e=>this.rename(e,item)} /> :
                                                        <Tooltip placement='topLeft' title={item.name}>
                                                            <span className='va-ml' onClick={()=>actionFileName&&this.openFile(item)}>{item.name}</span>
                                                        </Tooltip>
                                                    }
                                                </td>
                                            }
                                            {
                                                !mini && (
                                                    <td className='operation'>
                                                        {
                                                            !this.util_isFolder(item) && this.util_isPdfFile(item.docName) && !item.reviewSessionID && 
                                                            <Tooltip title={intl.get('FoxitStorage.Table.SendFileToOthers')}>
                                                                <a className="wc-icon-btn share" onClick={()=>this.onToolClick('Share',item)}></a>
                                                            </Tooltip>
                                                        }
                                                        {
                                                            !this.util_isFolder(item) && item.reviewSessionID && 
                                                            <Tooltip title={intl.get('FoxitStorage.Table.CopySharedLink')}>
                                                                <a className="wc-icon-btn copylink" onClick={()=>this.onToolClick('CopySharedLink',item)}></a>
                                                            </Tooltip>
                                                        }
                                                        {
                                                            !this.util_isFolder(item) && !item.isStarred && 
                                                            <Tooltip title={intl.get('FoxitStorage.Table.AddStar')}>
                                                                <a className="wc-icon-btn star" onClick={()=>this.onToolClick('AddStar',item)}></a>
                                                            </Tooltip>
                                                        }
                                                        {
                                                            !this.util_isFolder(item) && item.isStarred && 
                                                            <Tooltip title={intl.get('FoxitStorage.Table.RemoveStar')}>
                                                                <a className="wc-icon-btn star-fill" onClick={()=>this.onToolClick('RemoveStar',item)}></a>
                                                            </Tooltip>
                                                        }
                                                    </td>
                                                )
                                            }
                                            {
                                                !mini && (
                                                    <td className='status'>
                                                        {
                                                            this.util_isFolder(item) ? '--' : 
                                                            item.reviewSessionID ? <span className='status-text'>{intl.get('FoxitStorage.Table.Shared')}</span> : 
                                                            <span className='status-text'>{intl.get('FoxitStorage.Table.OnlyYou')}</span>
                                                        }
                                                    </td>
                                                )
                                            }
                                            <td>
                                            {
                                                activeTab==='Recent' ? 
                                                (this.util_formatDate(item.lastOpenTime)) :
                                                (this.util_formatDate(item.lastModifiedTime))
                                            }
                                            </td>
                                            <td>{bytesTobytes(item.docSize) || '--'}</td>
                                            {
                                                !mini && <td className='wx-table-column-50'>
                                                    <Dropdown trigger="hover" overlayClassName='storage-ant-dropdown' getPopupContainer={()=>{
                                                        // 用于修复 dropdown 滚动条闪烁问题
                                                        const id = 'storage-ant-dropdown-wrapper';
                                                        let $wrapper = document.getElementById(id);
                                                        if (!$wrapper) {
                                                            $wrapper = document.createElement('div');
                                                            $wrapper.id = id;
                                                            document.body.appendChild($wrapper);
                                                        }
                                                        return $wrapper;
                                                    }} overlay={this.renderMoreDropdownMenu(item)}>
                                                        <a className="wc-icon-btn more"></a>
                                                    </Dropdown>
                                                </td>
                                            }
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    }
                    {
                        pagabled && activeTab==='Documents' && !isDisableStorage && <Pagination showSizeChanger
                            size={mini?'small':'default'}
                            hideOnSinglePage={documentPaginationOption.total<10}
                            current={documentPaginationOption.pageIndex}
                            pageSize={documentPaginationOption.pageSize}
                            total={documentPaginationOption.total}
                            pageSizeOptions={['10', '30', '50', '100']}
                            onChange={e=>this.onPaginationChange(e)}
                            onShowSizeChange={this.onPaginationPageSizeChange}></Pagination>
                    }
                    {
                        // 添加文件夹窗口
                        activeTab==='Documents' && !isDisableStorage && <AddFolderDialog {...addFolderOption} onConfirm={e=>this.createFolder(e)} onHide={()=>{
                            addFolderOption.visible = false;
                            this.setState({ addFolderOption });
                        }}></AddFolderDialog>
                    }
                    {
                        // 移动文件窗口
                        activeTab==='Documents' && !isDisableStorage && moveToOtherFolderOption.visible && <MoveToOtherFolderDialog {...moveToOtherFolderOption} onConfirm={e=>this.moveToOtherFolder(e)} onHide={e=>this.hideMoveToOtherFolderDialog(e)}></MoveToOtherFolderDialog>
                    }
                </Spin>
            </div>
        );
    }
}
export default StorageTable;
